export default (obj, keys) => {
  return keys.reduce((filteredObj, key) => {
    if (obj.hasOwnProperty(key)) {
      filteredObj[key] = obj[key];
    }

    return filteredObj;
  }, {});
};
